import React, { useState } from 'react';
import { X, AlertCircle } from 'lucide-react';

interface TaskSwitchDialogProps {
  currentTaskTitle: string;
  newTaskTitle: string;
  onConfirm: (notes: string) => void;
  onCancel: () => void;
}

export function TaskSwitchDialog({
  currentTaskTitle,
  newTaskTitle,
  onConfirm,
  onCancel
}: TaskSwitchDialogProps) {
  const [notes, setNotes] = useState('');
  
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
        <div className="p-6">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center">
              <AlertCircle className="h-6 w-6 text-amber-500 mr-2" />
              <h2 className="text-lg font-semibold text-gray-900">Switch Task?</h2>
            </div>
            <button
              onClick={onCancel}
              className="text-gray-400 hover:text-gray-500"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          
          <div className="space-y-4">
            <div className="bg-gray-50 rounded-lg p-3">
              <p className="text-sm text-gray-600">Currently timing:</p>
              <p className="font-medium text-gray-900">{currentTaskTitle}</p>
            </div>
            
            <div className="bg-blue-50 rounded-lg p-3">
              <p className="text-sm text-gray-600">Switch to:</p>
              <p className="font-medium text-gray-900">{newTaskTitle}</p>
            </div>
            
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Add notes for current task (required)
              </label>
              <textarea
                value={notes}
                onChange={(e) => setNotes(e.target.value)}
                placeholder="What did you work on?"
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-500"
                rows={3}
                autoFocus
              />
            </div>
            
            <p className="text-sm text-gray-500">
              The timer will stop for the current task and start for the new task.
            </p>
          </div>
          
          <div className="mt-6 flex space-x-3">
            <button
              onClick={() => onConfirm(notes)}
              disabled={!notes.trim()}
              className={`flex-1 px-4 py-2 rounded-md font-medium ${
                notes.trim()
                  ? 'bg-indigo-600 text-white hover:bg-indigo-700'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              Switch Task
            </button>
            <button
              onClick={onCancel}
              className="flex-1 px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
            >
              Continue Current Task
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}